export class HolidayExceptionItemModel {
    public exceptionDate: Date;

    public exceptionDateFormatted: string;

    public orderHolidayExceptionID: number;

    public dayOfWeekSource: number;

    public orderCoef: number;

    public trainUID: string;

    public trainName: string;

    public trainDescription: string;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/holiday-exception-list/holiday-exception-item.model.ts